import { render, staticRenderFns } from "./updateload.vue?vue&type=template&id=186f2bce"
import script from "./updateload.vue?vue&type=script&lang=js"
export * from "./updateload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports